import './index.less'
import index from './index.vue'
import { render } from '@/utils/page'

render(index)
